import type { AppView } from "../types";

export const localTicketManagerUrl = "http://127.0.0.1:8765/";
const mobileNavigationQuery = "(max-width: 680px)";

export function shouldOpenLocalTicketManager(matchMedia = window.matchMedia.bind(window)) {
  return !matchMedia(mobileNavigationQuery).matches;
}

export function handleNavigation(
  next: AppView,
  navigateWeb: (view: AppView) => void,
  openLocal = (url: string) => window.location.assign(url),
  matchMedia = window.matchMedia.bind(window),
) {
  if (next === "tickets" && shouldOpenLocalTicketManager(matchMedia)) {
    openLocal(localTicketManagerUrl);
    return "local" as const;
  }
  navigateWeb(next);
  return "web" as const;
}
